// config.ts
import { Config } from "@adornis/config/config.js";
var routerConfig = new Config("adornis_router", {
  USE_VIRTUAL_ROUTING: {
    env: true,
    required: false,
    client: true,
    name: "USE_VIRTUAL_ROUTING",
    parse: (val) => val === "true",
    defaultVal: false
  },
  VIRTUAL_PATH: {
    env: true,
    required: false,
    client: true,
    name: "VIRTUAL_PATH",
    defaultVal: "/"
  },
  VIRTUAL_SEARCH_PARAMS: {
    env: true,
    required: false,
    client: true,
    name: "VIRTUAL_SEARCH_PARAMS",
    defaultVal: ""
  },
  VIRTUAL_HASH: {
    env: true,
    required: false,
    client: true,
    name: "VIRTUAL_HASH",
    defaultVal: ""
  }
});
export {
  routerConfig
};
